<div class="page-container">
  <div class="back-button-container">
    <button class="back-button" (click)="location.back()">
      <i class="fa-solid fa-arrow-left"></i>
    </button>
  </div>
  <div class="hero-card-container">
    @if (categoryLoading) {
      <p-skeleton
        borderRadius="12px"
        width="100%"
        height="268px"
        class="align-self-stretch" />
    } @else {
      <app-title-card [titleCard]="titleCard"></app-title-card>
    }
    <!-- add sponsor card here -->
    @if (sponsorCardsLoading && seminarCategory?.sponsorCardIds?.length > 0) {
      <div class="flex-r justify-center align-self-stretch">
        <p-skeleton width="670px" height="106px"></p-skeleton>
      </div>
    } @else if (seminarCategory?.sponsorCardIds?.length > 0) {
      <app-sponsor-card [sponsorCards]="sponsorCards"></app-sponsor-card>
    }
  </div>

  <div class="flex-c gap-24">
    <div class="nav-tabs">
      <div
        [class]="currentView === 'grid' ? 'nav-tab-active' : 'nav-tab'"
        (click)="changeView('grid')">
        <div class="nav-tab-text font-medium-title-large">Themen Ansicht</div>
        <div class="nav-tab-bar"></div>
      </div>
      <div
        [class]="currentView === 'list' ? 'nav-tab-active' : 'nav-tab'"
        (click)="changeView('list')">
        <div class="nav-tab-text font-medium-title-large">Listen Ansicht</div>
        <div class="nav-tab-bar"></div>
      </div>
    </div>
    @if (currentView === 'grid') {
      <div class="course-cards">
        <app-seminar-cards
          [showSearch]="true"
          [seminarCategory]="seminarCategory"
          [dataSource$]="dataSource$"
          [seminarsLoading]="seminarsLoading" />
      </div>
    } @else if (currentView === 'list') {
      <app-seminar-table
        class="seminar-table"
        [pageSize]="25"
        [pageSizeOptions]="[5, 10, 25, 50, 100, 200]"
        [seminarCategory]="seminarCategory"
        [dataSource$]="dataSource$"
        [isLoading]="seminarsLoading" />
    }
  </div>
  <app-topic-request></app-topic-request>
</div>
